(() => {
  'use strict';

  const POSTCODE_KEY = 'flowertime_postcode';
  const VERIFIED_POSTCODE_KEY = 'flowertime_verified_postcode';

  function initPostcodeWidget() {
    const pill = document.getElementById('ft-postcode-pill');
    const pillLabel = document.getElementById('ft-postcode-pill-label');
    const pillText = document.getElementById('ft-postcode-pill-text');
    const overlay = document.getElementById('ft-postcode-overlay');
    const closeButton = document.getElementById('ft-postcode-close');
    const clearButton = document.getElementById('ft-postcode-clear');
    const form = document.getElementById('ft-postcode-form');
    const input = document.getElementById('ft-postcode-input');
    const message = document.getElementById('ft-postcode-message');
    const submitButton = form?.querySelector('button[type="submit"]');

    if (
      !pill ||
      !pillLabel ||
      !pillText ||
      !overlay ||
      !closeButton ||
      !clearButton ||
      !form ||
      !input ||
      !message ||
      !submitButton
    ) {
      return;
    }

    let pendingAddToCartButton = null;
    let pendingButtonWasDisabled = false;
    let allowNextAddToCartClick = false;
    let modalTimer = null;
    let isChecking = false;

    const root = window.Shopify?.routes?.root || '/';

    function getSavedPostcode() {
      return localStorage.getItem(POSTCODE_KEY) || '';
    }

    function getVerifiedPostcode() {
      return localStorage.getItem(VERIFIED_POSTCODE_KEY) || '';
    }

    function saveVerifiedPostcode(postcode) {
      localStorage.setItem(POSTCODE_KEY, postcode);
      localStorage.setItem(VERIFIED_POSTCODE_KEY, postcode);
    }

    function saveUnverifiedPostcode(postcode) {
      localStorage.setItem(POSTCODE_KEY, postcode);
      localStorage.removeItem(VERIFIED_POSTCODE_KEY);
    }

    function clearSavedPostcode() {
      localStorage.removeItem(POSTCODE_KEY);
      localStorage.removeItem(VERIFIED_POSTCODE_KEY);
    }

    function updatePill(postcode) {
      if (postcode) {
        pillLabel.textContent = 'Levering til';
        pillText.textContent = postcode;
        pill.setAttribute('aria-label', `Levering til ${postcode}`);
      } else {
        pillLabel.textContent = 'Levering';
        pillText.textContent = 'Postnummer';
        pill.setAttribute('aria-label', 'Velg postnummer');
      }

      clearButton.hidden = !postcode;
    }

    function setMessage(text = '') {
      message.textContent = text;
    }

    function setCheckingState(checking) {
      isChecking = checking;
      input.disabled = checking;
      submitButton.disabled = checking;
      submitButton.textContent = checking ? 'Sjekker…' : 'Fortsett';
    }

    function nudgePill() {
      pill.classList.remove('ft-postcode-pill--nudge');

      requestAnimationFrame(() => {
        pill.classList.add('ft-postcode-pill--nudge');
      });

      window.setTimeout(() => {
        pill.classList.remove('ft-postcode-pill--nudge');
      }, 1000);
    }

    function openModal() {
      if (modalTimer) {
        window.clearTimeout(modalTimer);
        modalTimer = null;
      }

      input.value = getSavedPostcode();
      setMessage('');
      overlay.hidden = false;

      requestAnimationFrame(() => {
        input.focus();
        input.select();
      });
    }

    function restorePendingButton() {
      if (!pendingAddToCartButton) return;

      pendingAddToCartButton.disabled = pendingButtonWasDisabled;
    }

    function cancelPendingAddToCart() {
      restorePendingButton();
      pendingAddToCartButton = null;
      pendingButtonWasDisabled = false;
    }

    function closeModal({ cancelPending = true } = {}) {
      setCheckingState(false);
      overlay.hidden = true;

      if (cancelPending) {
        cancelPendingAddToCart();
      }
    }

    function getDeliveryRegion() {
      const component = document.querySelector(
        'product-component[data-delivery-region]'
      );

      return (
        component?.dataset.deliveryRegion?.trim().toLowerCase() || ''
      );
    }

    function postcodeNeedsVerification() {
      const postcode = getSavedPostcode();
      const verifiedPostcode = getVerifiedPostcode();

      return !postcode || postcode !== verifiedPostcode;
    }

    function getProductForm(button = null) {
      const formFromButton = button?.closest(
        'form[action*="/cart/add"]'
      );

      if (formFromButton) return formFromButton;

      const productComponent = document.querySelector(
        'product-component[data-delivery-region]'
      );

      const formFromProduct = productComponent?.querySelector(
        'form[action*="/cart/add"]'
      );

      if (formFromProduct) return formFromProduct;

      return document.querySelector('form[action*="/cart/add"]');
    }

    function createAddFormData(button = null) {
      const productForm = getProductForm(button);

      if (!productForm) {
        throw new Error('Product form was not found.');
      }

      const formData = new FormData(productForm);

      /*
       * Sticky Add to Cart kan ligge utenfor selve skjemaet.
       * Legg derfor inn aktiv variant manuelt hvis id mangler.
       */
      if (!formData.get('id')) {
        const stickyAddToCart = document.querySelector(
          'sticky-add-to-cart[data-current-variant-id]'
        );

        const variantId =
          stickyAddToCart?.dataset.currentVariantId ||
          document.querySelector('input[name="id"]')?.value;

        if (variantId) {
          formData.set('id', variantId);
        }
      }

      if (!formData.get('quantity')) {
        formData.set('quantity', '1');
      }

      if (!formData.get('id')) {
        throw new Error('Variant ID was not found.');
      }

      return formData;
    }

    async function fetchJSON(url, options = {}) {
      const response = await fetch(url, {
        credentials: 'same-origin',
        ...options,
      });

      let data = null;

      try {
        data = await response.json();
      } catch {
        data = null;
      }

      if (!response.ok) {
        const error = new Error(
          data?.description ||
            data?.message ||
            'Shopify request failed.'
        );

        error.status = response.status;
        throw error;
      }

      return data;
    }

    async function getCart() {
      return fetchJSON(`${root}cart.js`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });
    }

    async function temporarilyAddProduct(button) {
      const formData = createAddFormData(button);

      return fetchJSON(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      });
    }

    async function restoreCart(snapshot) {
      const currentCart = await getCart();
      const previousQuantities = new Map(
        snapshot.items.map((item) => [item.key, item.quantity])
      );

      const updates = {};

      currentCart.items.forEach((item) => {
        updates[item.key] = previousQuantities.get(item.key) ?? 0;
      });

      if (Object.keys(updates).length === 0) return;

      await fetchJSON(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
    }

    async function getShippingRates(postcode) {
      const params = new URLSearchParams({
        'shipping_address[zip]': postcode,
        'shipping_address[country]': 'Norway',
      });

      const data = await fetchJSON(
        `${root}cart/shipping_rates.json?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        }
      );

      return Array.isArray(data?.shipping_rates)
        ? data.shipping_rates
        : [];
    }

    function hasLocalDelivery(rates) {
      return rates.some((rate) => {
        const values = [
          rate?.name,
          rate?.code,
          rate?.presentment_name,
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();

        return values.includes('local delivery');
      });
    }

    /*
     * 暫時加入目前商品，讓 Shopify 可以根據購物車內容查配送。
     * 查詢完成後，再把購物車完整恢復到查詢前狀態。
     */
    async function validatePostcodeWithPendingProduct(postcode) {
      const cartSnapshot = await getCart();
      let temporaryProductAdded = false;

      try {
        await temporarilyAddProduct(pendingAddToCartButton);
        temporaryProductAdded = true;

        const rates = await getShippingRates(postcode);

        return hasLocalDelivery(rates);
      } finally {
        if (temporaryProductAdded) {
          await restoreCart(cartSnapshot);
        }
      }
    }

    /*
     * 客人直接點膠囊修改郵編時：
     * 如果購物車已有商品，直接用目前購物車查詢。
     * 如果購物車為空但正在商品頁，暫時加入該商品查詢。
     */
    async function validatePostcodeWithoutPendingProduct(postcode) {
      const cart = await getCart();

      if (cart.item_count > 0) {
        const rates = await getShippingRates(postcode);
        return {
          verified: true,
          deliverable: hasLocalDelivery(rates),
        };
      }

      if (getDeliveryRegion() === 'oslo') {
        const cartSnapshot = cart;
        let temporaryProductAdded = false;

        try {
          await temporarilyAddProduct(null);
          temporaryProductAdded = true;

          const rates = await getShippingRates(postcode);

          return {
            verified: true,
            deliverable: hasLocalDelivery(rates),
          };
        } finally {
          if (temporaryProductAdded) {
            await restoreCart(cartSnapshot);
          }
        }
      }

      /*
       * 非商品頁且購物車為空時，Shopify 無法計算配送方式。
       * 先記住郵編，但標記為尚未驗證。
       * 下次加入 Oslo 商品時會再次驗證。
       */
      return {
        verified: false,
        deliverable: true,
      };
    }

    function continueOriginalAddToCart() {
        if (!pendingAddToCartButton) return;

        const buttonToSubmit = pendingAddToCartButton;
        const productForm =
            buttonToSubmit.closest('form[action*="/cart/add"]') ||
            getProductForm(buttonToSubmit);

        restorePendingButton();

        pendingAddToCartButton = null;
        pendingButtonWasDisabled = false;
        allowNextAddToCartClick = true;

        window.setTimeout(() => {
            if (productForm && typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit(buttonToSubmit);
            } else {
            buttonToSubmit.click();
            }

            window.setTimeout(() => {
            allowNextAddToCartClick = false;
            }, 500);
        }, 200);
    }

    function beginPostcodeRequest(button) {
      pendingAddToCartButton = button;
      pendingButtonWasDisabled = button.disabled;
      button.disabled = true;

      nudgePill();

      modalTimer = window.setTimeout(() => {
        openModal();
      }, 300);
    }

    updatePill(getSavedPostcode());

    pill.addEventListener('click', openModal);

    closeButton.addEventListener('click', () => {
      if (!isChecking) closeModal();
    });

    clearButton.addEventListener('click', () => {
        if (isChecking) return;

        clearSavedPostcode();
        input.value = '';
        setMessage('');
        setCheckingState(false);
        updatePill('');
        closeModal();
    });

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay && !isChecking) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        !overlay.hidden &&
        !isChecking
      ) {
        closeModal();
      }
    });

    /*
     * 在 Horizon 執行加入購物車之前攔截 Oslo 商品。
     */
    document.addEventListener(
      'pointerdown',
      (event) => {
        const addToCartButton = event.target.closest(
          '.add-to-cart-button'
        );

        if (!addToCartButton || allowNextAddToCartClick) return;

        if (
          getDeliveryRegion() === 'oslo' &&
          postcodeNeedsVerification()
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          beginPostcodeRequest(addToCartButton);
        }
      },
      true
    );

    /*
     * 阻止 pointerdown 後仍可能產生的 click。
     * 同時作為鍵盤操作的備用攔截。
     */
    document.addEventListener(
      'click',
      (event) => {
        const addToCartButton = event.target.closest(
          '.add-to-cart-button'
        );

        if (!addToCartButton) return;

        if (allowNextAddToCartClick) {
          allowNextAddToCartClick = false;
          return;
        }

        if (pendingAddToCartButton) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return;
        }

        if (
          getDeliveryRegion() === 'oslo' &&
          postcodeNeedsVerification()
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          beginPostcodeRequest(addToCartButton);
        }
      },
      true
    );

    input.addEventListener('input', () => {
        input.removeAttribute('aria-invalid');
        setMessage('');
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (isChecking) return;

      const postcode = input.value.trim();

      if (!/^\d{4}$/.test(postcode)) {
        setMessage(
          'Skriv inn et gyldig firesifret postnummer.'
        );
        return;
      }

      setMessage('');
      setCheckingState(true);

      try {
        let result;

        if (pendingAddToCartButton) {
          const deliverable =
            await validatePostcodeWithPendingProduct(postcode);

          result = {
            verified: true,
            deliverable,
          };
        } else {
          result =
            await validatePostcodeWithoutPendingProduct(postcode);
        }

        if (!result.deliverable) {
            input.setAttribute('aria-invalid', 'true');

            setMessage(
                'Vi leverer dessverre ikke til dette postnummeret. Prøv et annet postnummer.'
            );

            return;
        }

        input.removeAttribute('aria-invalid');

        if (result.verified) {
          saveVerifiedPostcode(postcode);
        } else {
          saveUnverifiedPostcode(postcode);
        }

        updatePill(postcode);
        closeModal({ cancelPending: false });

        if (pendingAddToCartButton) {
          continueOriginalAddToCart();
        }
      } catch (error) {
        console.error(
          'Flowertime postcode validation failed:',
          error
        );

        setMessage(
          'Vi kunne ikke kontrollere postnummeret akkurat nå. Prøv igjen.'
        );
      } finally {
        setCheckingState(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initPostcodeWidget
    );
  } else {
    initPostcodeWidget();
  }
})();